import { getData } from 'helpers/RequestHelper';

export const callBankNameEndpoint = (routingNumber) => {
  return getData({
    url: `/register/lookup/bank_name?number=${routingNumber}`
  })
    .then((response) => response.data.name)
    .catch((error) => {
      window.Raven.captureException(error);
      return '';
    });
};
